import AppData from '../../Model/MerchantAppData';
import BaseFirebaseRepository from './BaseFirebaseRepository';

const instances = {}
const defaultInstanceKey = Math.random()

export default class TableDetailRepository extends BaseFirebaseRepository {
    /**
     * @param {*} app 
     * @return {TableDetailRepository}
     */
    static getInstance(app) {
        if (app == null) {
            // By default, use instance created from main App
            app = AppData.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new TableDetailRepository(app)
            instances[app].tableRadius = 0.04
        }
        return instances[app]
    }
    constructor(app) {
        super(app)
    }
    getRef = () => {
        if (!merchant_id) {
            throw "Invalid 'merchant_id'"
        }
        return firebase.database().ref(firebase_path + '/table_details/')
        .orderByChild('merchant_id')
            .equalTo(parseInt(merchant_id))
    }
    getBaseObject = () => {
        return this.getDefaultTableDetail()
    }
    sort = () => {
        return (a,b) => {
            return a.sort - b.sort
        }
    }

    getDefaultTableDetail = () => {
        return {
            x: 0.1,
            y: 0.1,
            width: this.tableRadius,
            height: this.tableRadius,
            type: 'circle',
            cr_tl: 0,
            cr_tr: 0,
            cr_bl: 0,
            cr_br: 0,
            show_border: true,
        }
    }

    setTableRadius = (tableRadius) => {
        this.tableRadius = tableRadius
        return this
    }
}